import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@fast-ai/ui-components';

const styles = {
	root: {
		display: 'inline-flex',
		alignItems: 'center',
		borderRadius: 'circle',
		borderWidth: '2px',
		borderStyle: 'solid',
		flexDirection: 'column',
		fontSize: [1, 2, 2],
		pointerEvents: 'none',
		px: [1, 1, 2],
		textAlign: 'center',
		transition: 'all 1000ms',
		zIndex: 0,
		color: 'body',
		borderColor: 'body',
	},
	unit: {
		fontSize: ['12px', '12px', '12px'],
		color: 'inherit',
	},
	value: {
		zIndex: 1,
		fontWeight: 'bold',
		margin: 'auto',
		p: '1px',
	},
};

const Pill = forwardRef(({ sx, value, unit, ...rest }, ref) => (
	<Box
		ref={ref}
		sx={{
			...styles.root,
			...sx,
		}}
		{...rest}
	>
		<Box as="span" sx={styles.value}>
			{value}
			{unit && (
				<Text as="span" sx={styles.unit}>
					{unit}
				</Text>
			)}
		</Box>
	</Box>
));

Pill.propTypes = {
	unit: PropTypes.node,
	value: PropTypes.node,
	variant: PropTypes.string,
};

Pill.displayName = 'Pill';

export default Pill;
